import { render } from "./TaskInfo.vue?vue&type=template&id=b1e092ec"
import script from "./TaskInfo.vue?vue&type=script&lang=js"
export * from "./TaskInfo.vue?vue&type=script&lang=js"

import "./TaskInfo.vue?vue&type=style&index=0&id=b1e092ec&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__